export default __webpack_public_path__ + "static/media/doc4.e7c445f3.jpg";